import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=6f018258&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f018258')) {
      api.createRecord('6f018258', component.options)
    } else {
      api.reload('6f018258', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=6f018258&", function () {
      api.rerender('6f018258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SIGRzOx1gJCY/JS/comp/openstreetmap.vue"
export default component.exports